module.exports = __webpack_public_path__ + "static/semantic-icon-inverted-49acddfb7be0caebb862dbd1bcd8eef5.png";